import { Component } from '@poa/core';
import React from 'react';
import { observable } from '@poa/state';
import { getProfileIcon } from '../../icons/profile';
import Spinner from 'react-spinkit';
import moment from 'moment';

const placeholederImage = require('../../../img/placeholder_man.jpg');


class GeneralInfoProfile extends React.Component {
    store; // injected by Poa
    actions; // injected by Poa

    localState = observable({
        isEdit: false,
        descriptionAction: null,
        tagsAction: null,
        profile: {}
    });


    handleEditButtonClick = () => {
        const { selectedProfile } = this.store.generalProfile;
        if (!this.localState.isEdit) {
            this.localState.profile = { ...selectedProfile };
            this.localState.isEdit = true;
        }
    }

    handleRefreshAction = (e) => {
        const tenSecondsAgo = moment().utc().subtract(10, 'seconds');

        if (this.localState.descriptionAction && this.localState.descriptionAction <= tenSecondsAgo) {
            this.localState.descriptionAction = null;
        }
        if (this.localState.tagsAction && this.localState.tagsAction <= tenSecondsAgo) {
            this.localState.tagsAction = null;
        }

        if (this.localState.descriptionAction !== null || this.localState.tagsAction !== null) {
            setTimeout(() => {
                this.handleRefreshAction(e);
            }, 1000);
        }
    }

    handlDescriptionAction = async (e) => {
        this.localState.descriptionAction = moment().utc();
        try {
            await this.actions.generalProfileActions.sendProfileAction(
                this.store.generalProfile.selectedProfile.bx_sender_data.id,
                "summary",
            );
            this.handleRefreshAction(e);
        } catch (e) {
            console.error(e);
        }
    }

    handlTagsAction = async (e) => {
        this.localState.tagsAction = moment().utc();
        try {
            await this.actions.generalProfileActions.sendProfileAction(
                this.store.generalProfile.selectedProfile.bx_sender_data.id,
                "tags",
            );

            this.handleRefreshAction(e);
        } catch (e) {
            console.error(e);
        }
    }

    handleSaveButtonClick = async () => {
        try {
            await this.actions.generalProfileActions.updateGeneralProfile(
                this.localState.profile.payer_id,
                this.localState.profile
            );
            this.localState.isEdit = false;
        } catch (e) {
            console.error(e);
        }
    }

    handleCancelEditButtonClick = () => {
        this.localState.isEdit = false;
    }

    render() {
        const { selectedProfile, is_loading } = this.store.generalProfile;

        return (
            <div className='general_info__content'>
                {
                    is_loading ? (
                        <div
                            className='spinner-loading'
                            style={{ paddingTop: '15px', paddingBottom: '65px', textAlign: 'center' }}
                        >
                            <Spinner name='folding-cube' fadeIn='none' />
                        </div>
                    ) : (
                        selectedProfile.id ?
                            <>
                                <div className='main-row'>
                                    <div>
                                        <div className='title-name'>
                                            {
                                                this.localState.isEdit ?
                                                    <input
                                                        type='text'
                                                        className='input-name'
                                                        value={this.localState.profile.name}
                                                        onChange={e => this.localState.profile.name = e.target.value}
                                                    />
                                                    :
                                                    (selectedProfile.name || 'empty')
                                            }
                                            {
                                                !this.localState.isEdit ?
                                                    <button
                                                        onClick={this.handleEditButtonClick}
                                                        className='edit-button'>
                                                        {getProfileIcon('pencil')}
                                                    </button> :
                                                    <button
                                                        onClick={this.handleSaveButtonClick}
                                                        className='edit-button-active'>
                                                        Cохранить
                                                    </button>
                                            }
                                            {
                                                (this.store.generalProfile.selectedProfile.bx_sender_data &&
                                                    this.store.generalProfile.selectedProfile.bx_sender_data.id) &&
                                                (
                                                    <button
                                                        onClick={this.handlTagsAction}
                                                        disabled={this.localState.tagsAction !== null}
                                                        className='edit-button long_button'>
                                                        Собрать данные
                                                        {
                                                            (this.localState.tagsAction !== null) ?
                                                                getProfileIcon('refresh')
                                                                : null
                                                        }
                                                    </button>
                                                )
                                            }

                                            {this.localState.isEdit &&
                                                <button
                                                    onClick={this.handleCancelEditButtonClick}
                                                    className='edit-button-cancel'>
                                                    Отменить
                                                </button>
                                            }
                                        </div>
                                        <div className='row-info'>
                                            <img className='row-img'
                                                src={placeholederImage}
                                                onError={(e) => { e.target.src = placeholederImage; }}
                                                alt='client-profile' />
                                            <div className="info-column">
                                                <div className='info-row'>
                                                    {getProfileIcon('birthday')}
                                                    <div className='info-text'>Дата Рождения :</div>
                                                    {
                                                        !this.localState.isEdit ?
                                                            <div className='info-text'>
                                                                {selectedProfile.date_of_birth || 'empty'}
                                                            </div>
                                                            :
                                                            <input
                                                                type='text'
                                                                className='input-name'
                                                                value={this.localState.profile.date_of_birth}
                                                                onChange={e => this.localState.profile.date_of_birth = e.target.value}>
                                                            </input>
                                                    }
                                                </div>
                                                <div className='info-row'>
                                                    {getProfileIcon('suitcase')}
                                                    {
                                                        !this.localState.isEdit ?
                                                            <div className='info-text'>
                                                                {selectedProfile.profession || 'empty'}
                                                            </div>
                                                            :
                                                            <input
                                                                type='text'
                                                                className='input-name'
                                                                value={this.localState.profile.profession}
                                                                onChange={e => this.localState.profile.profession = e.target.value}>
                                                            </input>
                                                    }
                                                </div>
                                                <div className='info-row'>
                                                    {getProfileIcon('location')}
                                                    {
                                                        !this.localState.isEdit ?
                                                            <div className='info-text'>
                                                                {selectedProfile.address || 'empty'}
                                                            </div>
                                                            :
                                                            <input
                                                                type='text'
                                                                className='input-name'
                                                                value={this.localState.profile.address}
                                                                onChange={e => this.localState.profile.address = e.target.value}>
                                                            </input>
                                                    }
                                                </div>
                                                <div className='info-row'>
                                                    {getProfileIcon('email')}
                                                    {
                                                        !this.localState.isEdit ?
                                                            <div className='info-text'>
                                                                {selectedProfile.email || 'empty'}
                                                            </div>
                                                            :
                                                            <input
                                                                type='text'
                                                                className='input-name'
                                                                value={this.localState.profile.email}
                                                                onChange={e => this.localState.profile.email = e.target.value}>
                                                            </input>
                                                    }
                                                </div>
                                            </div>
                                            {
                                                selectedProfile.bx_sender_data && selectedProfile.bx_sender_data.tags && (
                                                    <div className="info-column">
                                                        {
                                                            selectedProfile.bx_sender_data.tags.map(
                                                                (tag, index) => (
                                                                    <div className='info-row' key={index}>
                                                                        {getProfileIcon('idCard')}
                                                                        <div className='info-title'>{tag.type} :</div>
                                                                        <div className='info-text'>{tag.value}</div>
                                                                    </div>
                                                                )
                                                            )
                                                        }
                                                    </div>
                                                )
                                            }

                                            <div className="info-column">
                                                <div className='info-row'>
                                                    {getProfileIcon('idCard')}
                                                    <div className='info-title'>ID :</div>
                                                    <div className='info-operator-name'>{selectedProfile.payer_id}</div>
                                                </div>
                                                <div className='info-row'>
                                                    {getProfileIcon('dollar')}
                                                    <div className='info-title'>Донат :</div>
                                                    <div className='info-donate'>$ {selectedProfile.donated}</div>
                                                </div>
                                                <div className='info-row'>
                                                    {getProfileIcon('group')}
                                                    <div className='info-title'>Анкет :</div>
                                                    <div className='info-accounts'>{selectedProfile.accounts}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='main-row'>
                                    <div style={{ width: '100%' }}>
                                        <div className='row-title'>
                                            Сводка
                                            {(this.store.generalProfile.selectedProfile.bx_sender_data &&
                                                this.store.generalProfile.selectedProfile.bx_sender_data.id) &&
                                                (<button
                                                    onClick={this.handlDescriptionAction}
                                                    disabled={this.localState.descriptionAction !== null}
                                                    className='edit-button long_button'>
                                                    Собрать данные
                                                    {
                                                        (this.localState.descriptionAction !== null) ?
                                                            getProfileIcon('refresh')
                                                            : null
                                                    }
                                                </button>)
                                            }
                                        </div>
                                        <div className='row-description'>
                                            <div dangerouslySetInnerHTML={{ __html: selectedProfile.bx_sender_data.summary || selectedProfile.short_description }} />
                                        </div>
                                        {
                                            this.localState.isEdit ?
                                                <div style={{ width: '100%' }}>
                                                    <div className='row-title'>Важно : </div>
                                                    <input
                                                        type='text'
                                                        className='input-label'
                                                        value={this.localState.profile.short_label}
                                                        onChange={e => this.localState.profile.short_label = e.target.value}
                                                    />
                                                </div>
                                                :
                                                <div className='row-label'>
                                                    <div className='label-title'>Важно : </div>
                                                    <div className='label-text'>{selectedProfile.short_label || 'empty'}</div>
                                                </div>
                                        }
                                    </div>
                                </div>
                                <div className='main-row'>
                                    <div style={{ width: '100%' }}>
                                        <div className='row-title'>Общая характеристика</div>
                                        {
                                            this.localState.isEdit ?
                                                <textarea
                                                    type='text'
                                                    className='input-text'
                                                    value={this.localState.profile.description}
                                                    onChange={e => this.localState.profile.description = e.target.value}
                                                /> :
                                                <div className='row-description'>
                                                    <div dangerouslySetInnerHTML={{ __html: selectedProfile.description || 'empty' }} />
                                                </div>
                                        }
                                    </div>
                                </div>
                            </>
                            :
                            <div className='main-row'>
                                <div className='no-profile-found-text'>
                                    {getProfileIcon('noUser')}
                                    Профиль не найден
                                </div>
                            </div>
                    )
                }
            </div>
        );
    }
}

export default Component({ namespaces: ['general-info-profile'] })(GeneralInfoProfile);